/**
 * Whether a room-channel join is a fresh entry into the room.
 *
 * Sent as `fresh: true` in the `phx_join` payload, and signaling then drops a
 * presenter grant left from an earlier visit (RoomChannel do_join/4). A
 * moderator grants presenter for a visit; kept across leaving, it let someone
 * refresh, or leave and rejoin, and go on sharing the whiteboard and documents
 * without being asked again.
 *
 * Fresh: the first time this meeting screen enters a room — a page load (so a
 * refresh), or the screen mounting again after a leave.
 * Not fresh: an automatic rejoin after a dropped socket (`joinedBefore`), where
 * a network blip must cost nothing, and coming back to a room this screen was
 * already in, such as the main room after a breakout room.
 */
export function isFreshJoin(
  topic: string | undefined,
  joinedBefore: boolean,
  entered: ReadonlySet<string>,
): boolean {
  return !joinedBefore && !!topic && !entered.has(topic)
}
